<template>
  <div>
    <swiper
      pagination
      :modules="modules"
      :space-between="20"
      :slides-per-view="1"
      :centered-slides="true"
    >
      <swiper-slide
        v-for="(item, key) in items"
        :key="key"
      >
        <ContentSectionTwoCard :card="item" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {
  Swiper, SwiperSlide,
} from 'swiper/vue'
import { Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'ContentSectionTwoSwiper',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    modules: [Pagination],
  }),
};
</script>
